<template>
  <div class="footer">
    <div class="container">
      <div class="row">
        <div class="col-md-3 col-sm-6">
          <h5>Quick links</h5>
          <div class="quick-links-content">
            <a href="https://www.signify.com/oem" target="_blank">
              Signify OEM</a
            >
          </div>
        </div>

        <div class="col-md-3 col-sm-6 ml-auto">
          <div class="follow-us-content">
            <div class="signify"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="lint">
      <div class="container">
        <div class="lint-content">
          <a href="https://www.signify.com" target="_blank">Owner of site</a>
          <a
            href="https://www.signify.com/global/privacy/legal-information/cookies-notice"
            target="_blank"
            >Cookies</a
          >
          <a
            href="https://www.signify.com/global/privacy/legal-information/privacy-notice"
            target="_blank"
            >Privacy</a
          >
          <a href="https://www.signify.com/global/terms-of-use" target="_blank"
            >Terms of use</a
          >
          <a
            href="https://www.signify.com/global/product-security"
            target="_blank"
            >Product security</a
          >
          <router-link to="/acknowledgement">Acknowledgement</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style lang="scss" scoped>
a {
  color: $white;
  text-decoration: none;
  &:hover {
    color: $white;
    &::after {
      text-decoration: none;
    }
  }
}

.footer {
  background-color: #3c3c41;
  color: $white;

  .row {
    padding: 1.5rem 0;
  }

  .quick-links-content {
    a {
      display: block;
      color: $white;
    }
  }

  .follow-us-content {
    height: 100%;
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-end;

    .signify {
      background: url("../../assets/images/signify.png") no-repeat;
      background-position: bottom right;
      background-size: contain;
      height: 100%;
      margin-top: auto;
      width: 100%;
      max-width: 200px;
    }
  }
  .lint {
    background-color: #252525;
    color: $white;
    .lint-content {
      display: inline-block;
      padding: 0.5rem 0;
      a {
        color: $white;

        &::after {
          content: "|";
          padding: 0 1rem;
        }
        &:last-child {
          &::after {
            content: "";
          }
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    .signify {
      max-width: 175px !important;
    }
  }

  @media screen and (max-width: 576px) {
    .signify {
      height: 75px !important;
    }
  }

  @media screen and (max-width: 374px) {
    .signify {
      max-width: 150px !important;
    }
  }
}
</style>
